import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
import { volumes } from '../data/volumes';
export function VolumesSection() {
  return <section id="volumes" className="bg-acad-canvas px-4 py-20 sm:py-28" data-id="element-241" data-mp="coiskmopx5mr">
      <div className="mx-auto max-w-6xl" data-id="element-242" data-mp="cmeskftxwqrr">
        <div className="mx-auto max-w-3xl text-center" data-id="element-243" data-mp="7owk0qju4dka">
          <p className="text-sm font-bold uppercase tracking-[0.16em] text-acad-gold" data-id="element-244" data-mp="7nbl6oqhm8gm">
            Your 6-in-1 teaching system
          </p>
          <h2 className="mt-3 font-display text-4xl font-semibold text-acad-ink sm:text-5xl" data-id="element-245" data-mp="3c45zvrudw3ag">
            Six Complete Professional Volumes Working Together as One
          </h2>
          <p className="mt-4 text-base leading-7 text-acad-muted" data-id="element-246" data-mp="3l4aypdlihtd0">
            Instead of buying isolated resources for technique, rhythm,
            planning, advanced skills, musicality, and assessment, you get all
            six inside one complete Tap Dance teaching system.
          </p>
        </div>

        <div className="mt-14 grid gap-6 md:grid-cols-2" data-id="element-247" data-mp="29fs1o8ipxx6r">
          {volumes.map((volume, index) => <motion.article key={volume.number} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.1
        }} transition={{
          duration: 0.28,
          delay: index % 2 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex h-full flex-col rounded-2xl border border-acad-line bg-white p-6 shadow-card sm:p-8" data-id="element-248" data-mp="2ee1z6prx19vj" data-mpi={index}>
              <p className="text-xs font-bold uppercase tracking-[0.15em] text-acad-gold" data-id="element-249" data-mp="24hyylocppjap">
                {volume.number}
              </p>
              <h3 className="mt-2 font-display text-2xl font-semibold text-acad-ink sm:text-3xl" data-id="element-250" data-mp="3fvkppf24tuyv">
                {volume.title}
              </h3>
              <p className="mt-3 border-l-2 border-acad-gold pl-4 text-sm font-medium leading-6 text-acad-goldDark" data-id="element-251" data-mp="1gphsetfu4o6r">
                {volume.subtitle}
              </p>
              <p className="mt-5 text-sm leading-6 text-acad-muted" data-id="element-252" data-mp="1ps0uhbbsqwry">
                {volume.intro}
              </p>
              <div className="mt-6" data-id="element-253" data-mp="1kth8xc147n04">
                <h4 className="text-xs font-bold uppercase tracking-[0.13em] text-acad-muted" data-id="element-254" data-mp="1kqbh3p13q70p">
                  What does this solve in your teaching?
                </h4>
                <p className="mt-2 text-sm leading-6 text-acad-muted" data-id="element-255" data-mp="t2jjqhxyikje">
                  {volume.problem}
                </p>
              </div>
              <p className="mt-6 text-xs font-bold uppercase tracking-[0.13em] text-acad-muted" data-id="element-256" data-mp="121wuddxthf5p">
                {volume.listLabel}
              </p>
              <ul className="mt-3 space-y-2.5" data-id="element-257" data-mp="eb12kgtd2jyg">
                {volume.bullets.map(bullet => <li key={bullet} className="flex gap-2.5 text-sm leading-6 text-acad-muted" data-id="element-258" data-mp="9chea9raow2x">
                    <CheckCircle2Icon size={17} className="mt-0.5 shrink-0 text-acad-gold" aria-hidden="true" data-id="element-259" data-mp="2pr2qhojgap5o" />
                    {bullet}
                  </li>)}
              </ul>
              <div className="mt-auto pt-7" data-id="element-260" data-mp="34olntfa72aoq">
                <p className="rounded-xl border border-acad-gold/45 bg-acad-goldSoft/50 p-4 text-sm leading-6 text-acad-ink" data-id="element-261" data-mp="34pn0tpart793">
                  <strong className="font-semibold text-acad-goldDark" data-id="element-262" data-mp="38pdwo7f5mdkh">
                    Result:{' '}
                  </strong>
                  {volume.result}
                </p>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}